import {
  Button,
  CircularProgress,
  Dialog,
  IconButton,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material'
import { IconX } from '@tabler/icons-react'

export type SimpleDialogProps = {
  title: string
  text: string
  description?: string
  onSubmit: () => void
  onClose?: () => void
  open: boolean
  isLoading?: boolean
  color?: 'primary' | 'error'
  confirmText?: string
  disabled?: boolean
}

export const SimpleDialog = ({
  open,
  text,
  title,
  description,
  onSubmit,
  onClose,
  isLoading = false,
  color = 'primary',
  confirmText = 'Confirm',
  disabled,
}: SimpleDialogProps) => {
  const handleClose = () => {
    onClose?.()
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <Stack py={2} px={4} gap={2}>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="h6">{title}</Typography>
          <IconButton onClick={handleClose}>
            <SvgIcon>
              <IconX />
            </SvgIcon>
          </IconButton>
        </Stack>
        <Stack gap={2}>
          <Stack gap={2}>
            <Typography variant="body1">{text}</Typography>
            {description ? (
              <Typography variant="body2" color="text.secondary" whiteSpace="pre-line">
                {description}
              </Typography>
            ) : null}
          </Stack>
          <Stack direction="row" gap={2} justifyContent="flex-end">
            <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color={color}
              onClick={onSubmit}
              disabled={disabled || isLoading}
              startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : undefined}
            >
              {confirmText}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Dialog>
  )
}
